import React from 'react'
import classNames from 'classnames'
import Btn from './Btn'
import { ReactSVG } from 'react-svg'

const ExpandedContent = ({
  previewCount,
  className,
  render,
  showControls = true
}: {
  previewCount: number
  render: (limit: number) => React.ReactElement
  className?: string
  showControls?: boolean
}) => {
  const [limit, setLimit] = React.useState(previewCount)
  const [active, setActive] = React.useState(false)

  const buttonText = React.useMemo(
    () => (active ? 'Скрыть' : 'Показать все'),
    [active]
  )

  const handleClick = () => {
    setLimit(active ? previewCount : 9999)
    setActive(!active)
  }

  return (
    <div className={classNames('expanded-content', className)}>
      <div className={'expanded-content__content'}>{render(limit)}</div>

      {showControls && (
        <div className={'expanded-content__controls'}>
          <Btn
            onClick={handleClick}
            className={classNames({ active })}
            small
            text
          >
            <span>{buttonText}</span>
            <ReactSVG src={'/i/svg/chevron-down.svg'} wrapper={'span'} />
          </Btn>
        </div>
      )}
    </div>
  )
}

export default ExpandedContent
